var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.9,12.8L0,11.1l8-8l8,8l-1.9,1.9L8,6.8L1.9,12.8z","fill":"currentColor"}));
}

ChevronUp.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
